import { buildPrintIntent } from '../../lib/intent-url';
import { useAuthStore } from '../../stores/auth.store';

interface PrintButtonProps {
  data?: string; // ESC/POS data as base64 or raw text
  label?: string;
  className?: string;
}

export default function PrintButton({ data, label = 'Print', className }: PrintButtonProps) {
  const shop = useAuthStore((s) => s.shop);

  function handlePrint() {
    if (!data) {
      window.print();
      return;
    }

    const printerIp = shop?.ip_address;
    const printerPort = shop?.printer_port ?? '9100';

    if (printerIp) {
      // Try Android intent URL for ESC/POS direct printing
      const intentUrl = buildPrintIntent(printerIp, printerPort, data);
      const a = document.createElement('a');
      a.href = intentUrl;
      a.click();
    } else {
      window.print();
    }
  }

  return (
    <button
      className={`btn btn--primary${className ? ` ${className}` : ''}`}
      onClick={handlePrint}
      type="button"
    >
      🖨️ {label}
    </button>
  );
}
